import { render, staticRenderFns } from "./Fenye.vue?vue&type=template&id=53deb5d9&scoped=true&"
import script from "./Fenye.vue?vue&type=script&lang=js&"
export * from "./Fenye.vue?vue&type=script&lang=js&"
import style0 from "./Fenye.vue?vue&type=style&index=0&id=53deb5d9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53deb5d9",
  null
  
)

export default component.exports